export const LOGIN_FETCH = 'auth/LOGIN_FETCH';
export const SETUP_PASSWORD = 'auth/SETUP_PASSWORD';
export const FORGET_PASSWORD = 'auth/FORGET_PASSWORD';
export const LOGOUT_FETCH = 'auth/LOGOUT_FETCH';
export const API_ERROR = 'auth/API_ERROR';
export const SET_FIRST_LOGIN_FLAG = 'auth/SET_FIRST_LOGIN_FLAG';
export const SWITCH_EMPLOYER_ADMIN_AUTH = 'auth/SWITCH_EMPLOYER_ADMIN_AUTH';
export const IMPERSONATE = 'auth/IMPERSONATE';
export const CANCEL_IMPERSONATE = 'auth/CANCEL_IMPERSONATE';
